import React, { useContext, useState, useEffect } from 'react'
import Loader from 'react-loader-spinner'
import gameServices from '../../../services/game-service'
import sessionStorage from '../../../utils/userSessionStorage'
import {
  competitionId,
  numWinners,
} from '../../../constants/activity-constants'
import useMediaQuery from '../../../utils/useMediaQuery'

import { Context } from './../../../context/app-context'

import top from '../../../assets/images/top.png'
import logoVNosotras from '../../../assets/images/logoVNosotras.png'

import './top.scss'
import Cardscroll from '../../atoms/card-scroll/card-scroll'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import getUserInfo from '../../../utils/getUserInfo'
import { jsonToHash } from '../../../utils/crypto'
import Show from '../../../utils/show'

const LOCALE =
  ['es-AR', 'es-CL', 'es-PE', 'es-PY', 'es-UY'].indexOf(process.env.LOCALE) > -1
    ? process.env.LOCALE
    : 'default'

const italatam = LOCALE === 'es-AR' || LOCALE === 'es-PY'

const userInfo = getUserInfo()
const handleClickLink = label => {
  pushEventData({
    event: 'Interacciones_Enlaces_VMatch',
    label,
    user_data: null,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}

export default function Top() {
  const { dispatch } = useContext(Context)
  const [topList, setTopList] = useState(null)
  const [session] = useState(new sessionStorage())
  const [userData, setUserData] = useState(null)

  const isMobile = useMediaQuery()

  const handleModalOpen = () => {
    dispatch({
      type: 'set-context',
      payload: {
        modalActive: {
          type: 'unauthenticated',
          props: {},
        },
      },
    })
  }

  const handlePerfil = () => {
    dispatch({
      type: 'set-context',
      payload: {
        modalActive: {
          type: 'userTop',
          props: {
            userName: userData.name,
            userPoints: userData.points,
            userPosition: userData.position,
          },
        },
      },
    })
  }

  useEffect(() => {
    let userLoging = session.getToken()
    let userInfo = session.getUserInfo()
    var config = undefined
    if (userLoging && userInfo) {
      config = {
        headers: {
          Authorization: userLoging.idToken,
        },
      }
    }

    gameServices.getTop(competitionId, config).then(res => {
      if (res.status === 200) {
        setTopList(res.data.topGame.slice(0, numWinners))
        if (res.data.point !== 0 || res.data.position !== 0) {
          setUserData({
            ...userData,
            name: userInfo?.name?.split(' ')[0],
            token: userLoging.idToken,
            points: res.data.point,
            position: res.data.position,
          })
          console.log(competitionId)
        }
      } else {
        setTopList([])
        console.log(competitionId)
      }
    })
  }, [])

  console.log(competitionId)

  useEffect(() => {
    if (userData != null) {
      handlePerfil()
    }
  }, [userData])
  return (
    <div className="top">
      <div className="top__container">
        <div className="top__container__title">
          <h2 className="family-Bw-Black size-34 color-white">TOP</h2>
        </div>
        <Cardscroll className="top__container-top">
          {userData === null && (
            <>
              <Show valid={!italatam}>
                <p className="top__container-top__description">
                  <a
                    className="top__container-top__description__links"
                    onClick={() => {
                      handleModalOpen()
                      handleClickLink('Inicia sesión')
                    }}
                  >
                    Inicia sesión{' '}
                  </a>
                  para conocer tu puntaje <br />
                  y tu posición dentro del top de jugadoras. <br />
                  <br />
                  Si aún no formas parte de NosotrasOnline <br />
                  regístrate{' '}
                  <a
                    onClick={() => handleClickLink('aquí')}
                    className="top__container-top__description__links"
                    href="/registro/"
                  >
                    aquí
                  </a>
                </p>
              </Show>
              <Show valid={italatam}>
                <p className="top__container-top__description">
                  <a
                    className="top__container-top__description__links"
                    onClick={() => {
                      handleModalOpen()
                      handleClickLink('Inicia sesión')
                    }}
                  >
                    Iniciá sesión{' '}
                  </a>
                  para conocer tu puntaje <br />
                  y tu posición dentro del top de jugadoras. <br />
                  <br />
                  Si aún no sos parte de NosotrasOnline <br />
                  regístrate{' '}
                  <a
                    onClick={() => handleClickLink('aquí')}
                    className="top__container-top__description__links"
                    href="/registro/"
                  >
                    acá
                  </a>
                </p>
              </Show>
            </>
          )}
          {topList === null && (
            // <p className="family-H-Medium size-18 color-white">
            <Loader type="TailSpin" color="#FFFFFF" height={30} width={30} />
            // </p>
          )}
          {topList !== null &&
            ((topList.length > 0 && (
              <div className="top__container-top__containerTable">
                <table>
                  <tr>
                    <th className="top__container-top__containerTable__subtitles --firtsColumn">
                      Nombre
                    </th>
                    <th className="top__container-top__containerTable__subtitles --secondColumn">
                      Correo
                    </th>
                  </tr>
                  {topList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="top__container-top__containerTable__tdText --firstColumn">
                          {index + 1}. {item.name}
                        </td>
                        <td className="top__container-top__containerTable__tdText --secondColumn">
                          {item.email}
                        </td>
                      </tr>
                    )
                  })}
                </table>
              </div>
            )) || (
              <>
                <p className="family-H-Medium size-18 color-white">
                  ¡Aun no hay usuarias en el top!
                </p>
                <button
                  className="btn-primary f-concentrate-top-btn"
                  onClick={handleModalOpen}
                >
                  ¡Jugar!
                </button>
              </>
            ))}
        </Cardscroll>
      </div>
    </div>
  )
}
